module.exports = __webpack_public_path__ + "media/images/pool_chairs-ae78f7b6.jpg";